import { IonRouterOutlet } from "@ionic/react";
import React, { useEffect } from "react";
import { Redirect, Route, useHistory, useLocation } from "react-router";
import PaymentScreen from "../components/chat/PaymentScreen";
import WebView from "../components/webview";
import TrackerComponent from "../containers/HomePage/StepAndSleepChart/index";
import homePage from "../containers/HomePage/homePage";
import AssesmentComponent from "../containers/assesment/assessment";
import CareTeamComponent from "../containers/careTeam/index";
import DocumentViewContainer from "../containers/documents/DocumentViewContainer";
import DocumentContainer from "../containers/documents/newIndex";
import DocumentContainerDoc from "../containers/documents/newIndexDoc";
import hamburger from "../containers/hamburger";
import HealthGoal from "../containers/healthGoals";
import HealthGoalScreenComponent from "../containers/healthGoals/healthGoalsScreen";
import HealthPlanComponent from "../containers/healthPlan/index";
import PaytmLogin from "../containers/login/PaytmLogin";
import MedicineOrderComponent from "../containers/medicineOrder/index";
import MeditationComponent from "../containers/meditation";
import PremiumPage from "../containers/premium/newIndex";
import PatientProfile from "../containers/profile/index";
import Registration from "../containers/registration/newIndex";
import Testimonials from "../containers/registration/testimonials";
import SubmittedReporting from "../containers/reporting/components/submittedReporting";
import ReportingContainer from "../containers/reporting/newIndex";
import VitalContainer from "../containers/vitals/newIndex";
import VitalsChart from "../containers/vitalsChart";

import IframeComponent from "../components/paytmOffers/IframeComponent";
import DentalCare from "../containers/HomePage/components/DentalCare";
import Diabetes from "../containers/diabetesDigit";
import Digit from "../containers/digit";
import CovidCare from "../containers/digit/CovidCare";
import HeartHealth from "../containers/digit/HeartHealth";
import WeightManagement from "../containers/digit/WeightManagement";
import WomenHealth from "../containers/digit/WomenHealth";
import SyncedVitals from "../containers/connectDevices/SyncedVitals";
import Settings from "../containers/settings/Settings";
import BookingHistory from "../containers/orderHistory";

import FamilyPlan from "../containers/familyInfo/newIndex";

import { CircularProgress } from "@mui/material";
import AddressBook from "../containers/address/newIndex";
import AddressBookDummy from "../containers/address/newIndexdummy";
import ManageAddress from "../containers/address/components/manageAddress";
import MedicineOrderComplete from "../containers/medicineOrderComplete";
import NavigoBooking from "../containers/navigo/newIndex";
import SessionExpired from "../containers/session-expired";
import SessionCheck from "../containers/sessionCheck/Sessioncheck";
import zylaWallet from "../containers/zylaWallet/newIndex";

import { Plugins } from "@capacitor/core";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CustomerSupport from "../containers/hamburger/coustmerSupportPage";
import LoginPage from "../containers/login/newLogin";
import OfflinePage from "../containers/offline";
import RootedPage from "../containers/isRooted";
import { Policy } from "../containers/policy/policyPage";
import Privacy from "../containers/privacy";
import TabPage from "../containers/tab";
import Terms from "../containers/terms";
import Faqs from "../containers/zylaWallet/rewardPages/faqs";
import RewardInfo from "../containers/zylaWallet/rewardPages/rewardInfo";
import RewardPointLedger from "../containers/zylaWallet/rewardPages/rewardPointLedger";
import RewardPointPage from "../containers/zylaWallet/rewardPages/rewardPointPage";

import Feed from "../containers/HomePage/Feed";
import Consultation from "../containers/mliNavigo/consultation";
import Diagnostics from "../containers/mliNavigo/DiagnosticPage";
import FullBodyHealthCheckup from "../containers/mliNavigo/BodyHealthCheckup";
import HealthAssesment from "../containers/mliNavigo/HealthAssesment";
import HealthRiskAssesment from "../containers/mliNavigo/HealthRiskAssesment";
import HealthRiskAssesment2 from "../containers/mliNavigo/HealthRiskAssesment2";
import { BookingSuccessfully } from "../containers/mliNavigo/component/BookingSuccessfully";
import { BookingSuccessfullyCard } from "../containers/medicineOrder/BookingSuccessfullyCard";

import { MYPlan2 } from "../containers/HomePage/components/MYPlan2";
import { EligibilityCheck } from "../containers/login/components/EligibilityCheck";
import TermsCondition from "../containers/login/components/termsCondition";
import GenerateVoucher from "../containers/login/components/generateVoucher";
import { MyPlan3 } from "../containers/HomePage/components/MyPlan3";
import RewardPoint from "../containers/rewardPoint";
import RegistrationPage from "../containers/registration/newIndex";
import StepathonStepCard from "../containers/stepathon/components/stepathonStepCrad";
import StepathonPage from "../containers/stepathon/stepathonPage";
import StepathonAboutPage from "../containers/stepathon/stepathonAboutPage";
import StepathonPage2 from "../containers/stepathon/stepathonPage2";
import { Network } from "@capacitor/network";
import CidrReward from "../containers/zylaWallet/rewardPages/cidrReward/cidrReward";
import AutoLogin from "../containers/autologin";
import { CapacitorJailbreakRootDetection } from "@evehr/capacitor-jailbreak-root-detection";
import SelectModePage from "../containers/navigo/components/select-mode";
import SelectLocation from "../containers/navigo/components/selectLocation";
import CentreFilters from "../containers/navigo/components/centreFilters";
import ProviderCard from "../containers/navigo/components/providerCard";
import ReasonScreen from "../containers/navigo/components/ReasonScreen";
import NavigoReschedule from "../containers/navigo/components/navigoReschedule";
import { setStateFromPayload } from "../containers/navigo/navigoSlice";
import BookingForSection from "../containers/navigo/components/bookingForSection";
import ServiceData from "../containers/navigo/components/serviceData";
import PBHome from "../PBHome";
import KnowYourPlan from "../containers/navigo/components/knowYourPlan";
import SecondMedicalOpinionLanding from "../containers/navigo/components/secondMedicalOpinionLanding";
import AssistedMedicalConcierge from "../containers/navigo/components/assistedMedicalConcierge";

export default function RouteComponent() {
  const [loaded, setLoaded] = useState(false);

  const [isRooted, setIsRooted] = useState(false);
  const isLoggedIn = useSelector((state) => state.login?.loggedIn);
  const isFirstLogin = useSelector((state) => state.login?.isFirstLogin);

  const isRegistered = useSelector((state) => state.login?.registered);
  const history = useHistory();
  const routeLocation = useLocation();
  const dispatch = useDispatch();

  // A payment modal must not outlive the screen that opened it.
  //
  // ZylaPay is rendered by /navigo (and providerCard), but the home-sample
  // booking runs in selectLocation — so the modal belongs to a page the user is
  // not on, and it is a MUI Dialog portaled to <body>, so it paints over
  // whatever IS on screen. Nothing cleared `openZylaPay` on navigation (the
  // reset below runs once, on mount), so cancelling could leave the payment
  // sheet covering the app while the URL moved on underneath it.
  //
  // Clearing it whenever the path changes is safe: no navigation is expected
  // while the payment sheet is up, and the post-payment flow has already set
  // this false before it navigates.
  useEffect(() => {
    dispatch(
      setStateFromPayload({ openZylaPay: false, paymentLoaderOrderId: "" })
    );
    // Depend on the whole location, not just the pathname. The payment page's
    // cancel DOES change the URL — but if it changes only the query string (or
    // pushes the same path again) a pathname-keyed effect never runs, which is
    // why the sheet stayed up. react-router hands back a new location object
    // for every navigation, so this fires on all of them.
  }, [routeLocation]);

  useEffect(() => {
    CapacitorJailbreakRootDetection.isJailbrokenOrRooted()
      .then((response) => {
        if (response.result == true) {
          setIsRooted(true);
        } else {
          CapacitorJailbreakRootDetection.isFridaRunning()
            .then((response2) => {
              if (response2.result == true) {
                setIsRooted(true);
              }
            })
            .catch((err) => {
              console.log("");
            });
        }
      })
      .catch((err) => {
        console.log("");
      });
    Network.getStatus()
      .then((status) => {
        if (status.connected === false) {
          // history.push("/offline");
          setLoaded(true);
        } else {
          setLoaded(true);
        }
      })
      .catch((err) => {
        setLoaded(true);
        console.log("cannot detect status");
      });
    dispatch(setStateFromPayload({ openZylaPay: false }));
  }, []);

  useEffect(() => {
    if (!isLoggedIn && window.isReload) {
      window.isReload = false;
      setTimeout(() => {
        const ele = document.getElementsByClassName("ion-page-hidden");
        if (ele && ele.length > 0) {
          document
            .getElementsByClassName("ion-page-hidden")[0]
            ?.classList.remove("ion-page-hidden");
        }
      }, 500);

      setLoaded(true);
    }
  }, [isLoggedIn]);

  // Auth guard for routes that need a login. Used as a <Route render={...}>
  // prop rather than via a wrapper component, on purpose:
  //
  // IonRouterOutlet only manages direct children that are <Route>/<Redirect>
  // ELEMENTS. The previous <PrivateRoute> wrapper was invisible to its view
  // stack, so those routes were never registered as views: navigating forward
  // still worked (react-router renders them regardless), but navigating BACK
  // to one left the outlet with no view to show and the screen went blank.
  // Auth behaviour here is identical to the old wrapper.
  const guarded = (Component) => (props) =>
    isLoggedIn ? (
      <Component {...props} />
    ) : window.location.pathname === "/session-expired" ? (
      <Redirect to="/session-expired" />
    ) : (
      <Redirect to="/login" />
    );

  return !isRooted ? (
    loaded ? (
      <IonRouterOutlet animated="false" className="responsive-class-ion-router">
        <Route exact path="/session-expired" component={SessionExpired}></Route>
        <Route exact path="/terms-condition" component={TermsCondition}></Route>
        <Route exact path="/select-mode" component={SelectModePage}></Route>
        <Route exact path="/select-location" component={SelectLocation}></Route>
        <Route exact path="/select-address" component={SelectLocation}></Route>
        <Route exact path="/centre-filters" component={CentreFilters}></Route>
        <Route exact path="/providerCard" component={ProviderCard}></Route>
        <Route exact path="/reasonScreen" component={ReasonScreen}></Route>
        <Route exact path="/navigoRes" component={NavigoReschedule}></Route>
        <Route exact path="/know-your-plan" component={KnowYourPlan}></Route>
        <Route
          exact
          path="/"
          render={() => {
            return <Redirect to="/login" />;
          }}
        />
        <Route exact path="/assessment" render={guarded(AssesmentComponent)} />
        <Route exact path="/bookingFor" render={guarded(BookingForSection)} />
        <Route path="/tab/feed" render={guarded(Feed)} />
        <Route
          exact
          path="/health-goals-screen"
          render={guarded(HealthGoalScreenComponent)}
        />
        <Route exact path="/home" render={guarded(homePage)} />
        <Route
          exact
          path="/login"
          render={() => {
            return isLoggedIn ? (
              isFirstLogin ? (
                <Redirect to="/terms-condition" push={true} />
              ) : (
                <Redirect to="/testimonials" />
              )
            ) : (
              <LoginPage />
            );
          }}
        ></Route>
        <Route exact path="/profile" render={guarded(PatientProfile)} />
        <Route path="/hamburger" render={guarded(hamburger)} />

        {/* <Route exact path="/careTeam" render={guarded(CareTeamComponent)} /> */}

        <Route path="/tab" render={guarded(TabPage)} />
        <Route exact path="/reporting" render={guarded(ReportingContainer)} />

        <Route
          exact
          path="/submittedReporting"
          render={guarded(SubmittedReporting)}
        />
        <Route exact path="/vitals" render={guarded(VitalContainer)} />
        <Route exact path="/dentalCare" render={guarded(DentalCare)} />
        <Route path="/diabetes" render={guarded(Diabetes)} />
        <Route path="/hearthealth" render={guarded(HeartHealth)} />
        <Route path="/weight-management" render={guarded(WeightManagement)} />
        <Route path="/covid19-care" render={guarded(CovidCare)} />
        <Route path="/womenhealth" render={guarded(WomenHealth)} />
        <Route exact path="/digit" component={Digit}></Route>
        <Route exact path="/documents" render={guarded(DocumentContainer)} />
        <Route
          exact
          path="/documents-doc"
          render={guarded(DocumentContainerDoc)}
        />
        <Route exact path="/document-viewer" render={guarded(WebView)} />
        <Route
          exact
          path="/documents/:type"
          render={guarded(DocumentViewContainer)}
        />
        <Route exact path="/trackingChart" render={guarded(TrackerComponent)} />
        <Route exact path="/meditation" render={guarded(MeditationComponent)} />
        <Route exact path="/vitalsChart" render={guarded(VitalsChart)} />
        <Route
          exact
          path="/doctor-consult/paytm-offer"
          render={(props) => (
            <IframeComponent
              {...props}
              url="https://zyla.in/doctor-consult/paytm-offer"
            />
          )}
        ></Route>
        <Route
          exact
          path="/webinars/6139cb79ee50930023811d55"
          render={(props) => (
            <IframeComponent
              {...props}
              url="https://zyla.in/webinars/6139cb79ee50930023811d55"
            />
          )}
        ></Route>
        <Route
          exact
          path="/webinars/612dc450fceb630023dd8441"
          render={(props) => (
            <IframeComponent
              {...props}
              url="https://zyla.in/webinars/612dc450fceb630023dd8441"
            />
          )}
        ></Route>
        <Route
          exact
          path="/doctor-consult/paytm-offer"
          render={(props) => (
            <IframeComponent
              {...props}
              url="https://zyla.in/doctor-consult/paytm-offer"
            />
          )}
        ></Route>
        <Route
          exact
          path="/webinars/6139cb79ee50930023811d55"
          render={(props) => (
            <IframeComponent
              {...props}
              url="https://zyla.in/webinars/6139cb79ee50930023811d55"
            />
          )}
        ></Route>

        <Route exact path="/payment" render={guarded(PaymentScreen)} />
        {/* <Route exact path="/hamburger" render={guarded(HamburgerPage)} /> */}
        <Route
          exact
          path="/medicine"
          render={guarded(MedicineOrderComponent)}
        />
        <Route
          exact
          path="/medicine/bookingCard"
          render={guarded(BookingSuccessfullyCard)}
        />
        <Route exact path="/premium" render={guarded(PremiumPage)} />

        <Route
          exact
          path="/risk-Assesment"
          render={guarded(HealthRiskAssesment)}
        />
        <Route
          exact
          path="/risk-Assesment2"
          render={guarded(HealthRiskAssesment2)}
        />
        <Route
          exact
          path="/body-health-checkup"
          render={guarded(FullBodyHealthCheckup)}
        />
        <Route
          exact
          path="/health-assesment"
          render={guarded(HealthAssesment)}
        />
        <Route exact path="/syncedVitals" render={guarded(SyncedVitals)} />
        <Route exact path="/settings" render={guarded(Settings)} />
        <Route exact path="/stepathon" render={guarded(StepathonPage)} />
        <Route exact path="/stepathon2" render={guarded(StepathonPage2)} />
        <Route
          exact
          path="/stepathonabout"
          render={guarded(StepathonAboutPage)}
        />
        <Route exact path="/family" render={guarded(FamilyPlan)} />
        <Route exact path="/address" render={guarded(AddressBook)} />
        <Route exact path="/manage-address" render={guarded(ManageAddress)} />
        <Route exact path="/address-dummy" render={guarded(AddressBookDummy)} />
        <Route exact path="/order-history" render={guarded(BookingHistory)} />
        <Route exact path="/sessioncheck" render={guarded(SessionCheck)} />
        {/* <Route exact path="/session-expired" render={guarded(SessionExpired)} /> */}
        <Route
          exact
          path="/ordercomplete"
          render={guarded(MedicineOrderComplete)}
        />
        <Route exact path="/navigo" render={guarded(NavigoBooking)} />
        <Route
          exact
          path="/second-medical-opinion"
          render={guarded(SecondMedicalOpinionLanding)}
        />
        <Route
          exact
          path="/assisted-medical-concierge"
          render={guarded(AssistedMedicalConcierge)}
        />
        <Route exact path="/mliNavigo" render={guarded(Consultation)} />
        <Route
          exact
          path="/mliNavigo/diagnostics"
          render={guarded(Diagnostics)}
        />
        <Route
          exact
          path="/mliNavigo/medicines"
          render={guarded(MedicineOrderComponent)}
        />
        <Route
          exact
          path="/mliNavigo/bookingCard"
          render={guarded(BookingSuccessfully)}
        />
        <Route exact path="/zylawallet" render={guarded(zylaWallet)} />
        <Route exact path="/offline" render={guarded(OfflinePage)} />
        <Route
          exact
          path="/health-plan"
          render={guarded(HealthPlanComponent)}
        />
        <Route exact path="/health-goals" render={guarded(HealthGoal)} />
        <Route exact path="/my-plan" render={guarded(MYPlan2)} />
        <Route exact path="/policy" render={guarded(Policy)} />
        <Route exact path="/sewa-myplan" render={guarded(MyPlan3)} />
        <Route exact path="/cidr-myplan" render={guarded(MyPlan3)} />

        <Route
          exact
          path="/coustmer-support"
          render={guarded(CustomerSupport)}
        />
        <Route exact path="/reward-point-info" render={guarded(RewardPoint)} />

        <Route
          exact
          path="/eligibility-check"
          component={EligibilityCheck}
        ></Route>
        <Route exact path="/pb-home" render={guarded(PBHome)} />
        <Route exact path="/privacy" component={Privacy}></Route>
        <Route exact path="/terms" component={Terms}></Route>
        <Route exact path="/testimonials" component={Testimonials}></Route>
        <Route exact path="/rewardInfo" component={RewardInfo}></Route>
        <Route
          exact
          path="/rewardPointPage"
          component={RewardPointPage}
        ></Route>

        <Route exact path="/faqs" component={Faqs}></Route>
        <Route exact path="/cidrReward/:_id" component={CidrReward}></Route>

        <Route
          exact
          path="/rewardPointLedger"
          component={RewardPointLedger}
        ></Route>
        <Route exact path="/terms-condition" component={TermsCondition}></Route>
        <Route exact path="/generate-voucher" component={GenerateVoucher} />
        <Route exact path="/registervoucher" component={RegistrationPage} />
        <Route exact path="/autologin" component={AutoLogin}></Route>
        <Route exact path="/serviceDetails" component={ServiceData}></Route>
      </IonRouterOutlet>
    ) : (
      <React.Fragment>
        <CircularProgress className="ion-router-circular-progress"></CircularProgress>
      </React.Fragment>
    )
  ) : (
    <RootedPage />
  );
}
